export default {
  "headerLinks": [{
    "name": "Car Values",
    "id": "navToCarValues",
    "url": "/car-values/",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::slp_own::my-cars-value::global",
    "pixallTag": "text-link::slp_own::my-cars-value::global",
    "omnitureTag": "carvalues_global-values",
    "dropdownItems": [{
      "name": "Price New/Used",
      "id": "navToCarValuesnavToNewUsedCarPrices",
      "url": "/car-prices/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_prices::price-new-used",
      "pixallTag": "text-link::slp_prices::price-new-used",
      "omnitureTag": "buy_global-values"
    }, {
      "name": "My Car's Value",
      "id": "navToCarValuesnavToTradeinPrivatePartyValues",
      "url": "/whats-my-car-worth/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_own::my-cars-value",
      "pixallTag": "text-link::slp_own::my-cars-value",
      "omnitureTag": "mycarworth_global-values"
    }, {
      "name": "Instant Cash Offer",
      "id": "navToCarValuesnavToInstantCashOffer",
      "url": "/instant-cash-offer/?Lp=73111D1C-71E5-4563-8EED-03932B322D6C&OfferCode=B&zip=[zipcode]&LNX=TIMKBBGNAVCV",
      "target": "replacezip",
      "partnerLink": "buybook",
      "googleTag": "text-link::global-nav-header::instant-cash-offer",
      "pixallTag": "text-link::global-nav-header::instant-cash-offer",
      "omnitureTag": "ico_global-values"
    }]
  }, {
    "name": "Cars for Sale",
    "id": "navToCarsForSale",
    "url": "/cars-for-sale/all",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::srp::cars-for-sale::global",
    "pixallTag": "text-link::srp::cars-for-sale::global",
    "omnitureTag": "inv_global-class",
    "dropdownItems": [{
      "name": "Cars for Sale",
      "id": "navToCarsforSalenavToCarsforSale",
      "url": "/cars-for-sale/all",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::srp::cars-for-sale",
      "pixallTag": "text-link::srp::cars-for-sale",
      "omnitureTag": "invsearch_global-class"
    }, {
      "name": "Free Dealer Price Quote",
      "id": "navToCarsforSalenavToFreeDealerPriceQuote",
      "url": "/free-dealer-price-quote/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_fdpq::free-dealer-price-quote",
      "pixallTag": "text-link::slp_fdpq::free-dealer-price-quote",
      "omnitureTag": "fdpq_global-class"
    }, {
      "name": "Vehicle History Report",
      "id": "navToCarsforSalenavToVehicleHistoryReport",
      "url": "/vehicle-history-report/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_partner::autocheck::vehicle-history-report",
      "pixallTag": "text-link::slp_partner::autocheck::vehicle-history-report",
      "omnitureTag": "vehhist_global-class"
    }, {
      "name": "Find Local Dealers",
      "id": "navToCarsforSalenavToFindLocalDealers",
      "url": "/dealers/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::srp_dealer::find-local-dealers",
      "pixallTag": "text-link::srp_dealer::find-local-dealers",
      "omnitureTag": "finddlr_global-class"
    }]
  }, {
    "name": "Private Seller Exchange",
    "id": "navToPrivateSellerExchange",
    "url": "/cars-for-sale/all/by-owner",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::srp::private-seller-cars::global",
    "pixallTag": "text-link::srp::private-seller-cars::global",
    "omnitureTag": "revrat_global-exprev",
    "dropdownItems": [{
      "name": "Private Seller Cars",
      "id": "navToPrivateSellerCarsExchange",
      "url": "/cars-for-sale/all/by-owner",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::srp::private-seller-cars",
      "pixallTag": "text-link::srp::private-seller-cars",
      "omnitureTag": ""
    }, {
      "name": "Sell Your Car",
      "id": "navToCarsforSalenavToSellYourCarExchange",
      "url": "/sell-your-car/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::syc_or_ico::sell-your-car",
      "pixallTag": "text-link::syc_or_ico::sell-your-car",
      "omnitureTag": "selltool_global-class"
    }]
  }, {
    "name": "Shop & Buy",
    "id": "navToShopAndBuy",
    "url": "/buying-shopping/",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::slp_buying-shopping::shop-and-buy::global",
    "pixallTag": "text-link::slp_buying-shopping::shop-and-buy::global",
    "omnitureTag": "revrat_global-exprev",
    "dropdownItems": [{
      "name": "Best Cars",
      "id": "navToCarReviewsnavToBestCars",
      "url": "/cars/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_best-cars::best-cars",
      "pixallTag": "text-link::slp_best-cars::best-cars",
      "omnitureTag": "slp_best-cars_global-exprev"
    }, {
      "name": "Dealer Reviews",
      "id": "navToDealerRatingSLP",
      "url": "/dealers/reviews/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_dealers_reviews::dealers-reviews",
      "pixallTag": "text-link::slp_dealers_reviews::dealers-reviews",
      "omnitureTag": "slp_dealers-reviews_global-exprev"
    }, {
      "name": "KBB Expert Reviews",
      "id": "navToCarReviewsnavToKBBExpertReviews",
      "url": "/car-reviews/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_reviews::kbb-expert-reviews",
      "pixallTag": "text-link::slp_reviews::kbb-expert-reviews",
      "omnitureTag": "exprev_global-exprev"
    }, {
      "name": "Electric Vehicle Guide",
      "id": "navToElectricVehiclesGuidenavToElectricVehiclesGuide",
      "url": "/electric-guide/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_electric-guide::electric-guide",
      "pixallTag": "text-link::slp_electric-guide::electric-guide",
      "omnitureTag": "slp_electric-guide_global-exprev"
    }, {
      "name": "KBB Awards",
      "id": "navToAwardsTopsnavToKBBAwards",
      "url": "/awards/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_awards::kbb-awards",
      "pixallTag": "text-link::slp_awards::kbb-awards",
      "omnitureTag": "award3_global-edtr"
    }, {
      "name": "Latest Car News",
      "id": "navToAwardsTopsnavToLatestCarNews",
      "url": "/car-news/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_car-news::latest-car-news",
      "pixallTag": "text-link::slp_car-news::latest-car-news",
      "omnitureTag": "news5_global-edtr"
    }, {
      "name": "Shopping & Buying",
      "id": "navToAwardsTopsnavToShop&Buy",
      "url": "/buying-shopping/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_buying-shopping::shop-and-buy",
      "pixallTag": "text-link::slp_buying-shopping::shop-and-buy",
      "omnitureTag": ""
    }]
  }, {
    "name": "Research Tools",
    "id": "navToResearchTools",
    "url": "/car-research/",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::slp_exprev::car-research::global",
    "pixallTag": "text-link::slp_exprev::car-research::global",
    "omnitureTag": "rschtools_global-rsch",
    "dropdownItems": [{
      "name": "Car Research",
      "id": "navToResearchToolsnavToCarResearch",
      "url": "/car-research/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_exprev::car-research",
      "pixallTag": "text-link::slp_exprev::car-research",
      "omnitureTag": "carresearch_global-rsch"
    }, {
      "name": "Browse Incentives",
      "id": "navToResearchToolsnavToBrowseIncentives",
      "url": "/best-cars/top-10-best-car-deals/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::editorial::browse-incentives",
      "pixallTag": "text-link::editorial::browse-incentives",
      "omnitureTag": "carresearch_global-rsch"
    }, {
      "name": "Car Loan Calculator",
      "id": "navToResearchToolsnavToCarLoanCalculator",
      "url": "/auto-loan-calculator/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_finance::auto-loan-calculator",
      "pixallTag": "text-link::slp_finance::auto-loan-calculator",
      "omnitureTag": "carresearch_global-rsch"
    }, {
      "name": "Car Finder",
      "id": "navToResearchToolsnavToVehicleSearchTool",
      "url": "/car-finder/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::results_new::car-finder",
      "pixallTag": "text-link::results_new::car-finder",
      "omnitureTag": "vehsrch_global-rsch"
    }, {
      "name": "Compare Cars",
      "id": "navToResearchToolsnavToCompare",
      "url": "/compare-cars/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_compare::compare-cars",
      "pixallTag": "text-link::slp_compare::compare-cars",
      "omnitureTag": "compare_global-rsch"
    }, {
      "name": "Car Loans",
      "id": "navToResearchToolsnavToCarLoans",
      "url": "/car-loans-and-financing/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_partner::car-loans",
      "pixallTag": "text-link::slp_partner::car-loans",
      "omnitureTag": "loan_global-rsch"
    }, {
      "name": "Insurance",
      "id": "navToResearchToolsnavToInsurance",
      "url": "/camp/root-insurance/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::insurance-compare::insurance",
      "pixallTag": "text-link::insurance-compare::insurance",
      "omnitureTag": "insure_global-rsch"
    }, {
      "name": "Check My Credit",
      "id": "navToResearchToolsnavToCheckMyCredit",
      "url": "/credit-score/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_partner::check-my-credit",
      "pixallTag": "text-link::slp_partner::check-my-credit",
      "omnitureTag": "credit_global-rsch"
    }, {
      "name": "Extended Warranty",
      "id": "navToResearchToolsnavToExtendedWarranty",
      "url": "/extended-auto-warranty/",
      "target": "_self",
      "partnerLink": "warrantydirect",
      "googleTag": "text-link::slp_extended-auto-warranty::extendend-warranty",
      "pixallTag": "text-link::slp_extended-auto-warranty::extendend-warranty",
      "omnitureTag": "warranty_global-rsch"
    }, {
      "name": "Vehicle History Report",
      "id": "navToResearchToolsnavToVehicleHistoryReport",
      "url": "/vehicle-history-report/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_partner::vehicle-history-report",
      "pixallTag": "text-link::slp_partner::vehicle-history-report",
      "omnitureTag": "vehhist_global-rsch"
    }]
  }, {
    "name": "Car Repair",
    "id": "navToServiceRepair",
    "url": "/auto-repair/",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::ymm_repair::auto-repair-prices::global",
    "pixallTag": "text-link::ymm_repair::auto-repair-prices::global",
    "omnitureTag": "repair_global_top-srvrpr",
    "dropdownItems": [{
      "name": "Auto Repair Prices",
      "id": "navToServiceRepairnavToServiceRepair",
      "url": "/auto-repair/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::ymm_repair::auto-repair-prices",
      "pixallTag": "text-link::ymm_repair::auto-repair-prices",
      "omnitureTag": "repair_global-srvrpr"
    }, {
      "name": "Car Recalls",
      "id": "navToServiceRepairnavToCarRecalls",
      "url": "/recall/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::ymm_recall::car-recalls",
      "pixallTag": "text-link::ymm_recall::car-recalls",
      "omnitureTag": "recall_global-srvrpr"
    }, {
      "name": "Maintenance Pricing",
      "id": "navToServiceRepairnavToMaintenanceSchedules",
      "url": "/maintenance-schedules/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::ymm_service::maintenance-pricing",
      "pixallTag": "text-link::ymm_service::maintenance-pricing",
      "omnitureTag": "maint_gobal-srvrpr"
    }, {
      "name": "Find an Auto Shop",
      "id": "navToServiceRepairnavToServiceCenters",
      "url": "/service-centers/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_ownership_dealer_list::find-an-auto-shop",
      "pixallTag": "text-link::slp_ownership_dealer_list::find-an-auto-shop",
      "omnitureTag": "dealerlist_gobal-srvrpr"
    }, {
      "name": "Service Advisor",
      "id": "navToServiceRepairnavToServiceRepairGuide",
      "url": "/service-repair-guide/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_service::service-and-repair-guide",
      "pixallTag": "text-link::slp_service::service-and-repair-guide",
      "omnitureTag": "guide_gobal-srvrpr"
    }, {
      "name": "OBD-II Codes",
      "id": "navToServiceRepairnavToObd2Guide",
      "url": "/obd-ii/on-board-diagnostics-guide/",
      "target": "_self",
      "partnerLink": "nx",
      "googleTag": "text-link::slp_service::slp-obd-guide",
      "pixallTag": "text-link::slp_service::slp-obd-guide",
      "omnitureTag": "obd-guide_global-srvrpr"
    }]
  }],
  "footerLinks": [{
    "name": "FAQ",
    "id": "navFooterFaq",
    "url": "/faq/new-cars/",
    "rel": "",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::faq",
    "pixallTag": "text-link::faq",
    "omnitureTag": "faq_"
  }, {
    "name": "Contact Us",
    "id": "navFooterContactUs",
    "url": "/contact-us/",
    "rel": "",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::contact-form::contact-us",
    "pixallTag": "text-link::contact-form::contact-us",
    "omnitureTag": "contactus_"
  }, {
    "name": "Do Not Sell My Personal Information",
    "id": "navFooterDontSellMyInfo",
    "url": "https://privacyportal.onetrust.com/webform/f8f92a39-69a1-4fd9-b11e-c1a105cfb5ae/29160aa7-a4a2-4b3c-91b5-db2812d91d3c",
    "rel": "nofollow",
    "target": "_blank",
    "partnerLink": "nx",
    "googleTag": "text-link::donotsellmypi::dont-sell-my-info",
    "pixallTag": "text-link::donotsellmypi::dont-sell-my-info",
    "omnitureTag": "ccpa_"
  }, {
    "name": "Do Not Process My Sensitive Information",
    "id": "navFooterDontProcessMyInfo",
    "url": "https://privacyportal.onetrust.com/webform/f8f92a39-69a1-4fd9-b11e-c1a105cfb5ae/29160aa7-a4a2-4b3c-91b5-db2812d91d3c",
    "rel": "nofollow",
    "target": "_blank",
    "partnerLink": "nx",
    "googleTag": "text-link::donotprocessmypi::dont-process-my-sensitive-info",
    "pixallTag": "text-link::donotprocessmypi::dont-process-my-sensitive-info",
    "omnitureTag": "ccpa_"
  }, {
    "name": "About Us",
    "id": "navFooterAboutUs",
    "url": "/company/about-us/",
    "rel": "",
    "target": "_self",
    "googleTag": "text-link::slp-about-us::about-us",
    "pixallTag": "text-link::slp-about-us::about-us",
    "partnerLink": "nx",
    "omnitureTag": "aboutus_"
  }, {
    "name": "Careers",
    "id": "navFooterCareers",
    "url": "https://jobs.coxenterprises.com/businesses/cox-automotive/kelley-blue-book/",
    "rel": "nofollow",
    "target": "_blank",
    "partnerLink": "nx",
    "googleTag": "text-link::careers",
    "pixallTag": "text-link::careers",
    "omnitureTag": "careers_"
  }, {
    "name": "Corporate",
    "id": "navFooterCorporate",
    "url": "https://www.coxautoinc.com/",
    "rel": "nofollow",
    "target": "_blank",
    "partnerLink": "atg",
    "googleTag": "text-link::corporate",
    "pixallTag": "text-link::corporate",
    "omnitureTag": "info_corporate_"
  }, {
    "name": "Marketing and Advertising Solutions",
    "id": "navFooterAdvertising",
    "url": "https://b2b.kbb.com/",
    "rel": "nofollow",
    "target": "_self",
    "partnerLink": "atg",
    "googleTag": "text-link::advertising",
    "pixallTag": "text-link::advertising",
    "omnitureTag": "info_advertising_"
  }, {
    "name": "Media",
    "id": "navFooterMedia",
    "url": "https://mediaroom.kbb.com/",
    "rel": "",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::media",
    "pixallTag": "text-link::media",
    "omnitureTag": "mediacenter_"
  }, {
    "name": "Site Map",
    "id": "navFooterSiteMap",
    "url": "/sitemap/",
    "rel": "",
    "target": "_self",
    "partnerLink": "nx",
    "googleTag": "text-link::sitemap::site-map",
    "pixallTag": "text-link::sitemap::site-map",
    "omnitureTag": "sitemap_"
  }, {
    "name": "KBB Brazil",
    "id": "navFooterKbbBrazil",
    "url": "https://www.kbb.com.br/",
    "rel": "",
    "target": "_blank",
    "partnerLink": "intl",
    "googleTag": "text-link::kbb-brazil",
    "pixallTag": "text-link::kbb-brazil",
    "omnitureTag": "kbbbrazil_"
  }, {
    "name": "KBB Canada",
    "id": "navFooterKbbCanada",
    "url": "https://www.kbb.ca/?utm_source=kbbus&utm_medium=link&utm_campaign=footer",
    "rel": "",
    "target": "_blank",
    "partnerLink": "intl",
    "googleTag": "text-link::kbb-canada",
    "pixallTag": "text-link::kbb-canada",
    "omnitureTag": "kbbca_"
  }]
};